import type { ReactNode } from 'react';

export const IS_MOBILE_REGEX =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export function normalizeString(string: string) {
  return string
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase();
}

export const checkIsEmail = (text: string) => {
  if (typeof text !== 'string') {
    return false;
  }
  return IS_EMAIL_REGEX.test(text.toLowerCase());
};
/**
 * Accordingly to RFC 5322
 */
const duplicatedPattern = "[-!#-'*+/-9=?a-z^-~]";
const IS_EMAIL_REGEX = new RegExp(
  `^(${duplicatedPattern}+(\\.${duplicatedPattern}+)*|"(!#-[^-~ \\t]|(\\\\[\\t -~]))+")@(${duplicatedPattern}+(\\.${duplicatedPattern}+)*|\\[[\\t -Z^-~]*])$`
);

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
};

export const replaceWithJSX = (
  content: string,
  match: string,
  replace: ReactNode
) =>
  content
    .split(match)
    .flatMap((i) => [i, replace])
    .slice(0, -1);

export const truncateString = (str: string, length: number) => {
  str = str.replace(/&nbsp;/g, ' ').replace(/<[^>]*>?/gm, '');
  return str.length > length ? str.slice(0, length) + '...' : str;
};

export const formatOpportunityDescription = (
  data: Record<string, string | string[]>,
  translate?: (id: string) => string
) =>
  Object.entries(data)
    .map(([key, value]) => {
      const question = translate ? translate(key) : key;
      const answer = typeof value === 'string' ? value : value.join(', ');
      return `${question}: ${answer}`;
    })
    .join(' | ');

export const formatOpportunityQuestionsAndAnswers = (
  data: Record<string, string | string[]>,
  translate?: (id: string) => string
) => {
  const fields: { [question: `questionAndAnswer${number}`]: string } = {};
  Object.entries(data).forEach(([question, answer], index) => {
    const formattedAnswer =
      typeof answer === 'string' ? answer : answer.join(', ');
    const formattedQuestion = translate ? translate(question) : question;

    fields[`questionAndAnswer${index + 1}`] =
      `${formattedQuestion}: ${formattedAnswer}`;
  });
  return fields;
};
